import { render, staticRenderFns } from "./ChannelOrderStates.vue?vue&type=template&id=3b38aeee"
import script from "./ChannelOrderStates.vue?vue&type=script&lang=js"
export * from "./ChannelOrderStates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports